import {mapGetters} from 'vuex';

import * as constants from '../constants';

export default {
  name: 'MixinShippingPrice',
  computed: {
    ...mapGetters([
      'currentChoiceConfig',
      'useSameAddressForShipping',
      'formData',
      'currentChoiceConfig'
    ])
  },
  methods: {
    /**
     * @return {string} shipping price according to current shipping country
     */
    getCurrentShippingPrice() {
      if (!this.currentChoiceConfig || !this.currentChoiceConfig.shippingAmount) {
        return '';
      }

      const shippingCountry = !this.useSameAddressForShipping && this.formData.shipping && this.formData.shipping.shippingCountry ?
        this.formData.shipping.shippingCountry :
        (this.formData.billing && this.formData.billing.billingCountry ?
          this.formData.billing.billingCountry :
          '');
      const shippingPrice = this.currentChoiceConfig.productType === constants.PRODUCT_TYPE_PHYSICAL && this.currentChoiceConfig.shippingAmount ?
        (this.currentChoiceConfig.shippingAmount[shippingCountry] || '') :
        '';
      return String(shippingPrice); // Convert float to string
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/shipping-price.js